import { api, apiCall } from "@api/api";
import { StreamerCorpus } from "@lib/types/generic";

export type GetStreamerCorpusRes = StreamerCorpus;

const getStreamerCorpus = async (talentDisplayName: string) =>
  apiCall(api.post<StreamerCorpus>("/getCorpusForTalent", { talentDisplayName }));

export default getStreamerCorpus;
